// import contracts from './contracts'
import { FarmConfig } from './types'

const farms: FarmConfig[] = []

export default farms
